import { render, staticRenderFns } from "./invitations-v2.modal.vue?vue&type=template&id=3d4c4dac&scoped=true"
import script from "./invitations-v2.modal.vue?vue&type=script&lang=js"
export * from "./invitations-v2.modal.vue?vue&type=script&lang=js"
import style0 from "./invitations-v2.modal.vue?vue&type=style&index=0&id=3d4c4dac&prod&lang=scss&scoped=true"
import style1 from "./invitations-v2.modal.vue?vue&type=style&index=1&id=3d4c4dac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4c4dac",
  null
  
)

export default component.exports